import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var AlignmentMiddle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.126C0 11.504.5 11 1.119 11H42.88C43.5 11 44 11.504 44 12.126c0 .622-.5 1.126-1.119 1.126H1.12A1.122 1.122 0 0 1 0 12.126ZM0 21.75c0-.622.5-1.126 1.119-1.126H42.88c.618 0 1.119.504 1.119 1.126 0 .622-.5 1.126-1.119 1.126H1.12A1.122 1.122 0 0 1 0 21.75ZM0 31.374c0-.622.5-1.126 1.119-1.126h20.076c.617 0 1.118.504 1.118 1.126 0 .622-.5 1.126-1.118 1.126H1.119A1.122 1.122 0 0 1 0 31.374Z"
  }));
});
AlignmentMiddle.displayName = 'AlignmentMiddle';
AlignmentMiddle.defaultProps = {
  'aria-label': 'AlignmentMiddle'
};
export default AlignmentMiddle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/AlignmentMiddle.js
// module id = 3526
// module chunks = 11